/* EMERY — Product Card Mobile Swipe (mobile-only, with desktop teardown) */
(function () {
  // ---- Device helpers -------------------------------------------------------
  const isMobile = () => {
  return window.matchMedia('(pointer: coarse)').matches &&
         window.matchMedia('(hover: none)').matches;
};

  // ---- State helpers --------------------------------------------------------
  function setIndex(mediaEl, idx) {
    mediaEl.dataset.snapIndex = String(idx);
    const fig = mediaEl.closest('.product-card__figure');
    if (fig) fig.dataset.snapIndex = String(idx);
  }

  function wrapAsSlide(node) {
    const slide = document.createElement('div');
    slide.className = 'touch-swipe-slide';
    slide.appendChild(node);
    return slide;
  }

  function buildTrack(mediaEl) {
    if (mediaEl.__track) return mediaEl.__track;

    const primary = mediaEl.querySelector('.product-card__image--primary');
    const secondary = mediaEl.querySelector('.product-card__image--secondary');
    if (!primary) return null;

    // Create horizontal track (primary then secondary if present)
    const track = document.createElement('div');
    track.className = 'touch-swipe-track';
    Object.assign(track.style, {
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      gap: '0',
      transform: 'translateX(0%)',
      willChange: 'transform'
    });

    [primary, secondary].filter(Boolean).forEach(img => {
      Object.assign(img.style, {
        position: 'static',
        inset: 'auto',
        display: 'block',
        width: '100%',
        height: 'auto',
        opacity: '1',
        transform: 'none',
        visibility: 'visible'
      });
      track.appendChild(wrapAsSlide(img));
    });

    mediaEl.innerHTML = '';
    mediaEl.appendChild(track);
    mediaEl.style.overflow = 'hidden';
    mediaEl.__track = track;
    return track;
  }

  // ---- Build one media element ---------------------------------------------
  function initOne(mediaEl) {
    if (mediaEl.__swipeBound) return;

    const track = buildTrack(mediaEl);
    if (!track) return;

    mediaEl.__swipeBound = true;
    setIndex(mediaEl, 0);

    let index = 0; // 0 primary, 1 secondary
    let startX = 0, startY = 0, width = mediaEl.clientWidth || 1;
    let dragging = false, suppressClick = false;
    const THRESHOLD = 0.18;   // swipe distance portion to change slide
    const RESIST = 0.35;      // edge resistance
    const SNAP_MS = 220;      // snap animation duration

    function setTransform(pct) { track.style.transform = `translateX(${pct}%)`; }
    function follow(dx) {
      const atFirst = index === 0 && dx > 0;
      const atLast  = index === 1 && dx < 0;
      const resistDx = (atFirst || atLast) ? dx * RESIST : dx;
      const pct = (-index * 100) + (resistDx / width * 100);
      setTransform(pct);
    }
    function snap(to) {
      index = to;
      setIndex(mediaEl, index);
      track.style.transition = `transform ${SNAP_MS}ms ease-out`;
      setTransform(-index * 100);
      const done = () => { track.style.transition = ''; track.removeEventListener('transitionend', done); };
      track.addEventListener('transitionend', done);
    }

    // Keep alignment on size changes
    let ro;
    if ('ResizeObserver' in window) {
      ro = new ResizeObserver(() => {
        width = mediaEl.clientWidth || 1;
        setTransform(-index * 100);
      });
      try { ro.observe(mediaEl); } catch(_) {}
    }

    mediaEl.addEventListener('touchstart', (e) => {
      const t = e.touches[0];
      startX = t.clientX; startY = t.clientY;
      width = mediaEl.clientWidth || 1;
      dragging = true; suppressClick = false;
      track.style.transition = '';
    }, { passive: true });

    mediaEl.addEventListener('touchmove', (e) => {
      if (!dragging) return;
      const t = e.touches[0];
      const dx = t.clientX - startX;
      const dy = t.clientY - startY;

      // If vertical scroll is stronger, give up
      if (Math.abs(dy) > Math.abs(dx)) {
        dragging = false; setTransform(-index * 100);
        return;
      }

      e.preventDefault(); // prevent page scroll while swiping
      e.stopPropagation(); // critical inside related-products slider
      follow(dx);
      suppressClick = Math.abs(dx) > 6;
    }, { passive: false });

    mediaEl.addEventListener('touchend', (e) => {
      if (!dragging) return;
      const dx = e.changedTouches[0].clientX - startX;
      const moved = Math.abs(dx) / (width || 1);
      if (moved > THRESHOLD) {
        if (dx < 0 && index === 0) snap(1);
        else if (dx > 0 && index === 1) snap(0);
        else snap(index);
      } else {
        snap(index);
      }
      dragging = false;
    }, { passive: true });

    // Prevent accidental navigation after a drag
    mediaEl.addEventListener('click', (e) => {
      if (suppressClick) { e.preventDefault(); e.stopPropagation(); suppressClick = false; }
    }, true);
  }

  // ---- Remove swipe DOM on non-mobile --------------------------------------
  function teardown(root = document) {
    root.querySelectorAll('.product-card .product-card__media').forEach((mediaEl) => {
      const track = mediaEl.__track;
      if (!track) return;

      const imgs = [];
      track.querySelectorAll('.touch-swipe-slide').forEach((slide) => {
        const child = slide.firstElementChild;
        if (child) imgs.push(child);
      });

      mediaEl.innerHTML = '';
      imgs.forEach((img) => {
        // Clean inline styles we set
        img.style.position = '';
        img.style.inset = '';
        img.style.display = '';
        img.style.width = '';
        img.style.height = '';
        img.style.opacity = '';
        img.style.transform = '';
        img.style.visibility = '';
        mediaEl.appendChild(img);
      });

      delete mediaEl.__track;
      delete mediaEl.__swipeBound;
      mediaEl.removeAttribute('data-snap-index');
      const fig = mediaEl.closest('.product-card__figure');
      if (fig) fig.removeAttribute('data-snap-index');
    });
  }

 // ---- Lazy init: only build a card's swipe track when it nears the viewport ----
  let _io = null;
  function getObserver() {
    if (_io || !('IntersectionObserver' in window)) return _io;
    _io = new IntersectionObserver((entries, obs) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          initOne(entry.target);      // build track only now
          obs.unobserve(entry.target); // one-time; done with this card
        }
      }
    }, { rootMargin: '400px 0px' });   // start ~400px before it scrolls in
    return _io;
  }

  // ---- Init across a root ---------------------------------------------------
  function init(root = document) {
    if (!isMobile()) return;
    const io = getObserver();
    root.querySelectorAll('.product-card .product-card__media').forEach((mediaEl) => {
      if (mediaEl.__swipeBound) return;   // already built
      if (io) io.observe(mediaEl);        // defer until near viewport
      else initOne(mediaEl);              // fallback: no IO support, build now
    });
  }

  // ---- Boot -----------------------------------------------------------------
  document.addEventListener('DOMContentLoaded', () => {
    const applyMode = () => {
      if (isMobile()) {
        init(document);
      } else {
        teardown(document);
      }
    };

    applyMode();
    // iOS fires 'resize' while scrolling (address bar shows/hides) — only react to real width changes
    let lastWidth = window.innerWidth;
    window.addEventListener('resize', () => {
      if (window.innerWidth === lastWidth) return;
      lastWidth = window.innerWidth;
      applyMode();
    });
    window.addEventListener('orientationchange', applyMode);

    // Shopify section & recommendation events
    document.addEventListener('shopify:section:load', (e) => applyMode());
    document.addEventListener('product-recommendations:loaded', (e) => applyMode());
    document.addEventListener('shopify:block:select', (e) => applyMode());
    document.addEventListener('shopify:block:deselect', (e) => applyMode());

    // Observe newly injected nodes; only act on mobile
    const mo = new MutationObserver((muts) => {
      if (!isMobile()) return;
      for (const m of muts) {
        m.addedNodes && m.addedNodes.forEach((n) => {
          if (!(n instanceof Element)) return;
          // Queue new cards (infinite scroll, filters) for lazy setup instead of building them all at once
          const queue = (el) => { if (el.__swipeBound) return; const io = getObserver(); io ? io.observe(el) : initOne(el); };
          if (n.matches && n.matches('.product-card .product-card__media')) queue(n);
          n.querySelectorAll && n.querySelectorAll('.product-card .product-card__media').forEach(queue);
        });
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });

    // Optional manual hook (for debugging)
    window.initMobileSlider = () => applyMode();
  });
})();